import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class QuickviewService {
  constructor(private http: HttpClient) {}

  // Example GET request
  getNotes(): Observable<any> {
    return this.http.get('assets/data/notes.json');
  }

  getUsers(): Observable<any> {
    return this.http.get('assets/data/users.json');
  }

  getChatMessages(): Observable<any> {
    return this.http.get('assets/data/messages.json');
  }

  // Example POST request
  postData(url: string, body: any): Observable<any> {
    return this.http.post(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }
}
